import { CHART_COMPONENTS } from '../../../../types';
import { MostCommonCoInvestorsChart } from '../../../../components/Charts/Leaderboard/MostCommonCoInvestors/MostCommonCoInvestorsCharts';
import { useMostCommonCoInvestors } from '../../hooks/useMostCommonCoInvestors';
import { IPortfolioChartProps } from './ChartComponent';

export function MostCommonCoInvestors(
  props: Pick<IPortfolioChartProps<unknown>, 'isFullScreen' | 'onOpenFullScreen' | 'view'>
) {
  const data = useMostCommonCoInvestors(props.view);

  return (
    <MostCommonCoInvestorsChart
      id={CHART_COMPONENTS.MOST_COMMON_CO_INVESTORS}
      width={640}
      data={data}
      isFullScreen={props.isFullScreen}
      onOpenFullScreen={props.onOpenFullScreen}
    />
  );
}
